import { render } from "./NotFound.vue?vue&type=template&id=44ec2b9b&scoped=true"
import script from "./NotFound.vue?vue&type=script&lang=js"
export * from "./NotFound.vue?vue&type=script&lang=js"

import "./NotFound.vue?vue&type=style&index=0&id=44ec2b9b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44ec2b9b"]])

export default __exports__